import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ActivatedRoute } from '@angular/router'
import {
  ElderHeaderComponent,
  ElderShellService,
  ElderThemeDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkItem } from '../work-item'
import { WorkItemContentComponent } from '../work-item-content/work-item-content.component'
import { MatDialogClose } from '@angular/material/dialog'
import { MatIconButton } from '@angular/material/button'

@Component({
  selector: 'app-work-item-content-side',
  templateUrl: './work-item-detail-side.component.html',
  styleUrl: './work-item-detail-side.component.scss',
  imports: [
    MatToolbar,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    ElderTranslatePipe,
    ElderHeaderComponent,
    ElderThemeDirective,
    WorkItemContentComponent,
  ],
})
export class WorkItemDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private shellService = inject(ElderShellService)
  item: WorkItem

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.item = route.snapshot.data['workItem']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /**
   * Cancel and close
   */
  cancel(): void {
    this.shellService.closeSideContent()
  }
}
